import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const WhatsNewIcon = () => (
    <Box
        sx={{
            bgcolor: "primary.main",
            borderRadius: "10px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "6em",
        }}
    >
        <Typography
            variant="body2"
            sx={{
                fontWeight: "bold",
                color: "#fefefe",
                px: 0.5,
            }}
        >
            New
        </Typography>
    </Box>
);

export default WhatsNewIcon;
